import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './layout.module.scss';
//import Header from '../header';
import Footer from '../footer';
import HeaderNew from '../headerNew';

export function Layout() {
    return(
        <div className={styles.container}>
            <HeaderNew/>
            <div className="outlet">
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}